<template>
  <a-card :bordered="false">

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <patientField-modal ref="modalForm" @ok="modalFormOk"></patientField-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import PatientFieldModal from './modules/PatientFieldModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: "PatientFieldList",
    mixins:[JeecgListMixin],
    components: {
      PatientFieldModal
    },
    data () {
      return {
        description: '全局默认受试者属性配置管理页面',
        // 表头
        columns: [
          {
            title: '字段名称',
            align:"center",
            dataIndex: 'name',
          },
          {
            title: '字段英文',
            align:"center",
            dataIndex: 'nameEn'
          },
          // {
          //   title: '字段名称',
          //   align:"center",
          //   dataIndex: 'fieldName'
          // },
          {
            title: '必填',
            align:"center",
            dataIndex: 'required',
            customRender: (t, r, i) => {
              if(t==='1'){
                return '是'
              }
              if(t==='0'){
                return '否'
              }
              return '-'
            }
          },
          {
            title: '导出基本信息',
            align:"center",
            dataIndex: 'exportInfo_dictText'
          },
          {
            title: '导出采集数据',
            align:"center",
            dataIndex: 'exportData_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/management/patientField/list",
          delete: "/management/patientField/delete",
        },
      }
    },
    computed: {
    },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>